import { createAsyncThunk } from '@reduxjs/toolkit';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

import { Tour } from './tour';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchToursForBlueprint = createAsyncThunk(
  'tour/fetchToursForUserInBlueprint',
  async (_, { rejectWithValue }) => {
    try {
      if (!ENVIRONMENT_URL) {
        return rejectWithValue('No environment URL found');
      }

      const accessToken = getBackrsToken();

      const response = await fetch(
        `${ENVIRONMENT_URL}/application-tour${!accessToken ? '/public' : ''}?application=blueprint`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
          },
        },
      );

      if (!response) {
        return null;
      }

      const tours = (await response.json()) as Tour[];

      return tours;
    } catch (error) {
      return rejectWithValue(`Failed to fetch tours with error: ${error}`);
    }
  },
);

export const postCompletingTourBlueprint = createAsyncThunk(
  'tour/postCompletingTour',
  async (tourId: number, { rejectWithValue }) => {
    try {
      if (!ENVIRONMENT_URL) {
        return rejectWithValue('No environment URL found');
      }

      const accessToken = getBackrsToken();

      if (!accessToken) {
        return null;
      }

      const response = await fetch(`${ENVIRONMENT_URL}/application-tour/complete/${tourId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response) {
        return null;
      }

      return (await response.json()) as Tour[];
    } catch (error) {
      return rejectWithValue(`Failed to post completing tour with error: ${error}`);
    }
  },
);
